import { createActionSuccess, createAsyncActions } from './utils'

const reducer = 'APPLICATIONS'

const updateApplicationSuccess = createActionSuccess(reducer, 'UPDATE')

const {
  action: getApplication,
  actionSuccess: getApplicationSuccess,
  actionFail: getApplicationFail
} = createAsyncActions(reducer, 'GET')

const {
  action: createApplication,
  actionSuccess: createApplicationSuccess,
  actionFail: createApplicationFail
} = createAsyncActions(reducer, 'CREATE')

const {
  action: confirmInstantRentCreditCheck,
  actionSuccess: confirmInstantRentCreditCheckSuccess,
  actionFail: confirmInstantRentCreditCheckFail
} = createAsyncActions(reducer, 'CONFIRM_INSTANT_RENT_CREDIT_CHECK')

const {
  action: editApplication,
  actionSuccess: editApplicationSuccess,
  actionFail: editApplicationFail
} = createAsyncActions(reducer, 'EDIT')

const {
  action: getApartmentApplications,
  actionSuccess: getApartmentApplicationsSuccess,
  actionFail: getApartmentApplicationsFail
} = createAsyncActions(reducer, 'APARTMENT_APPLICATIONS_GET')

const {
  action: getApartmentLead,
  actionSuccess: getApartmentLeadSuccess,
  actionFail: getApartmentLeadFail
} = createAsyncActions(reducer, 'GET_LEAD_DATA')

const {
  action: getConversation,
  actionSuccess: getConversationSuccess,
  actionFail: getConversationFail
} = createAsyncActions(reducer, 'GET_CONVERSATION')

const {
  action: listApplications,
  actionSuccess: listApplicationsSuccess,
  actionFail: listApplicationsFail
} = createAsyncActions(reducer, 'LIST')

const {
  action: initializeInstantRentApplication,
  actionSuccess: initializeInstantRentApplicationSuccess,
  actionFail: initializeInstantRentApplicationFail
} = createAsyncActions(reducer, 'INITIALIZE_INSTANT_RENT_APPLICATION')

const {
  action: saveInstantRentUserInfo,
  actionSuccess: saveInstantRentUserInfoSuccess,
  actionFail: saveInstantRentUserInfoFail
} = createAsyncActions(reducer, 'SAVE_INSTANT_RENT_USER_INFO')

const {
  action: acceptApplication,
  actionSuccess: acceptApplicationSuccess,
  actionFail: acceptApplicationFail
} = createAsyncActions(reducer, 'ACCEPT')

const {
  action: rejectApplication,
  actionSuccess: rejectApplicationSuccess,
  actionFail: rejectApplicationFail
} = createAsyncActions(reducer, 'REJECT')

const {
  action: updateApplicationAdminNotes,
  actionSuccess: updateApplicationAdminNotesSuccess,
  actionFail: updateApplicationAdminNotesFail
} = createAsyncActions(reducer, 'UPDATE_ADMIN_NOTES')

const {
  action: selectApplications,
  actionSuccess: selectApplicationsSuccess,
  actionFail: selectApplicationsFail
} = createAsyncActions(reducer, 'SELECT_APPLICATIONS')

const {
  action: updateApplicationPhoneShownByCode,
  actionSuccess: updateApplicationPhoneShownByCodeSuccess,
  actionFail: updateApplicationPhoneShownByCodeFail
} = createAsyncActions(reducer, 'UPDATE_PHONE_SHOWN_BY_CODE')

const {
  action: updateApplicationStatusByCode,
  actionSuccess: updateApplicationStatusByCodeSuccess,
  actionFail: updateApplicationStatusByCodeFail
} = createAsyncActions(reducer, 'UPDATE_STATUS_BY_CODE')

const {
  action: updateApplicationStatus,
  actionSuccess: updateApplicationStatusSuccess,
  actionFail: updateApplicationStatusFail
} = createAsyncActions(reducer, 'UPDATE_STATUS')

export {
  getApplication,
  getApplicationSuccess,
  getApplicationFail,
  updateApplicationSuccess,
  createApplication,
  createApplicationSuccess,
  createApplicationFail,
  confirmInstantRentCreditCheck,
  confirmInstantRentCreditCheckFail,
  confirmInstantRentCreditCheckSuccess,
  editApplication,
  editApplicationSuccess,
  editApplicationFail,
  getApartmentApplications,
  getApartmentApplicationsSuccess,
  getApartmentApplicationsFail,
  listApplications,
  listApplicationsFail,
  listApplicationsSuccess,
  acceptApplication,
  acceptApplicationSuccess,
  acceptApplicationFail,
  rejectApplication,
  rejectApplicationSuccess,
  rejectApplicationFail,
  updateApplicationAdminNotes,
  updateApplicationAdminNotesSuccess,
  updateApplicationAdminNotesFail,
  saveInstantRentUserInfo,
  saveInstantRentUserInfoSuccess,
  saveInstantRentUserInfoFail,
  initializeInstantRentApplication,
  initializeInstantRentApplicationFail,
  initializeInstantRentApplicationSuccess,
  selectApplications,
  selectApplicationsSuccess,
  selectApplicationsFail,
  updateApplicationPhoneShownByCode,
  updateApplicationPhoneShownByCodeSuccess,
  updateApplicationPhoneShownByCodeFail,
  updateApplicationStatusByCode,
  updateApplicationStatusByCodeSuccess,
  updateApplicationStatusByCodeFail,
  updateApplicationStatus,
  updateApplicationStatusSuccess,
  updateApplicationStatusFail,
  getApartmentLead,
  getApartmentLeadSuccess,
  getApartmentLeadFail,
  getConversation,
  getConversationSuccess,
  getConversationFail
}
